const SRHT_SCORE_MIN = 0;
const SRHT_SCORE_MAX = 2;

function normalizeScore(score) {
  if (score === null || typeof score === 'undefined' || String(score).trim() === '') {
    return null;
  }

  const numericScore = Number(score);
  if (!Number.isFinite(numericScore)) {
    return null;
  }

  return Math.min(SRHT_SCORE_MAX, Math.max(SRHT_SCORE_MIN, numericScore));
}

export function getSrhtCategoryScalePercent(score) {
  const normalizedScore = normalizeScore(score);
  if (normalizedScore === null) {
    return null;
  }

  return Number((((normalizedScore - SRHT_SCORE_MIN) / (SRHT_SCORE_MAX - SRHT_SCORE_MIN)) * 100).toFixed(2));
}

export function getSrhtCategoryScaleTone(score) {
  const normalizedScore = normalizeScore(score);
  if (normalizedScore === null) {
    return {
      label: 'Noch keine Daten',
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      textColor: 'rgba(0, 0, 0, 0.6)',
    };
  }

  if (normalizedScore < 0.4) {
    return {
      label: 'Kritisch',
      backgroundColor: '#FDECEC',
      textColor: '#A32020',
    };
  }

  if (normalizedScore < 0.8) {
    return {
      label: 'Schwach',
      backgroundColor: '#FFF1E0',
      textColor: '#B54708',
    };
  }

  if (normalizedScore < 1.2) {
    return {
      label: 'Stabil',
      backgroundColor: '#FFF7D6',
      textColor: '#8A6D1D',
    };
  }

  if (normalizedScore < 1.6) {
    return {
      label: 'Gut',
      backgroundColor: '#E6F4EA',
      textColor: '#1E6A3B',
    };
  }

  return {
    label: 'Stark',
    backgroundColor: '#D8F3DC',
    textColor: '#14532D',
  };
}